import { render, staticRenderFns } from "./l-phone-form.vue?vue&type=template&id=6990edfe&scoped=true&"
import script from "./l-phone-form.vue?vue&type=script&lang=js&"
export * from "./l-phone-form.vue?vue&type=script&lang=js&"
import style0 from "./l-phone-form.vue?vue&type=style&index=0&id=6990edfe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6990edfe",
  null
  
)

export default component.exports